<template>
    <!-- 软件服务 -->
    <div class="software_maintenance">
        <h1 class="partH1 containers" ref="HeaderTitle">软件服务</h1>

        <div class="software_main" v-for="(item,i) in software" :key="i">
            <div class="left_pic" :ref="'softwarePartimg'+i">
                <div class="shade" :ref="'shadeTranslate'+i"></div>
                <img :src="item.leftimg" :ref="'softwareImg'+i">
            </div>
            <div class="right_li">
                <h3 :ref="'liTitle'+i">{{item.rightul.title}}</h3>
                <ul class="right_li_ul" :class="item.rightul.mianli[0].info===''?'right_li_uls':''" :ref="'ul'+i">
                    <!-- 两次li，定义ref时需要根据外层循环i区分开，防止后面调动画函数时，不能区分造成效果不能正常展示 -->
                    <li v-for="(val,k) in item.rightul.mianli" :ref="i===0?'li'+k:'lis'+k">
                        <img :style="{marginTop:(val.info===''?'15px':'')}" :src="val.imgpic">
                        <h4 :style="{marginTop:(val.info===''?'25px':'')}">{{val.titleLi}}</h4>
                        <p>{{val.info}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import animationUtils from "@/utils/animationUtils.js";
    import animationIndex from "@/utils/animationIndex.js";

    export default {
        props: {
            software: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                // 软件服务右侧两个li
                liDom0: [],
                liDom1: [],
            }
        },
        mounted() {
            this.software.forEach((item, index) => { //获取需要给加动画的各个li的ref节点
                if (index === 0) {
                    item.rightul.mianli.forEach((val, k) => {
                        this.liDom0.push(this.$refs[`li${k}`][0].classList);
                    })
                } else if (index === 1) {
                    item.rightul.mianli.forEach((val, k) => {
                        this.liDom1.push(this.$refs[`lis${k}`][0].classList);
                    })
                }
            })
            window.addEventListener("scroll", this.menu);
        },
        beforeDestroy() { //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
            window.removeEventListener("scroll", this.menu)
        },
        methods: {
            menu() {
                //第三部分标题动画
                let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
                let HeaderTitle = this.$refs.HeaderTitle.classList;
                animationUtils.animations(
                    HeaderTitleOffsetTop,
                    HeaderTitle,
                    "activeTitle"
                );

                //第三部分图的动画左侧1.1
                let softwarePartimg0OffsetTop = this.$refs.softwarePartimg0[0].offsetTop; //获取当前元素距离文档顶部的高度
                let shadeTranslate0 = this.$refs.shadeTranslate0[0].classList; //遮罩样式数组
                let softwareImg0 = this.$refs.softwareImg0[0].classList; //图片样式数组
                animationUtils.animations(
                    softwarePartimg0OffsetTop,
                    shadeTranslate0,
                    "activeShade"
                );
                animationUtils.animations(
                    softwarePartimg0OffsetTop,
                    softwareImg0,
                    "activeImg"
                );
                //左侧 1.2
                let softwarePartimg1OffsetTop = this.$refs.softwarePartimg1[0].offsetTop; //获取当前元素距离文档顶部的高度
                let shadeTranslate1 = this.$refs.shadeTranslate1[0].classList; //遮罩样式数组
                let softwareImg1 = this.$refs.softwareImg1[0].classList; //图片样式数组
                animationUtils.animations(
                    softwarePartimg1OffsetTop,
                    shadeTranslate1,
                    "activeShade"
                );
                animationUtils.animations(
                    softwarePartimg1OffsetTop,
                    softwareImg1,
                    "activeImg"
                );

                //右侧1.1
                let ul0OffsetTop = this.$refs.ul0[0].offsetTop; //获取当前元素距离文档顶部的高度
                /**
                 * animationIndex第一个参数为需要动画的dom元素的高度，
                 * 第二个参数为li的每个单元的dom样式类数组
                 * 第三个参数为动画样式类名称
                 * 第四个参数为每个li动画执行间隔时间
                 * */
                animationIndex.animationIndex(ul0OffsetTop, this.liDom0, "fade--in", 800);
                // 右侧1.2
                let ul1OffsetTop = this.$refs.ul1[0].offsetTop; //获取当前元素距离文档顶部的高度
                animationIndex.animationIndex(ul1OffsetTop, this.liDom1, "fade--in", 800);
                //右侧两个部分的子标题1.1
                let liTitlt0OffsetTop = this.$refs.liTitle0[0].offsetTop; //获取当前元素距离文档顶部的高度
                let liTitlt0 = this.$refs.liTitle0[0].classList;
                animationUtils.animations(
                    liTitlt0OffsetTop,
                    liTitlt0,
                    "activeTitle"
                );
                // 右侧1.2
                let liTitlt1OffsetTop = this.$refs.liTitle1[0].offsetTop; //获取当前元素距离文档顶部的高度
                let liTitlt1 = this.$refs.liTitle1[0].classList;
                animationUtils.animations(
                    liTitlt1OffsetTop,
                    liTitlt1,
                    "activeTitle"
                );
            }
        },
    };
</script>

<style scoped>
    @media screen and (max-width: 898px) {
        .right_li_ul li h4,.right_li_uls li h4 {
            margin-top: 0px !important;
        }
        .right_li_uls li h4 {
            padding: 15px 0;
        }

        .right_li_ul p {
            line-height: 2em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
        }
        .right_li_ul h4{
            padding: 5px 0;
        }
    }

    @media screen and (min-width: 898px) and (max-width: 1060px) {
        .right_li_ul li h4,.right_li_uls li h4{
            margin-top: 8px !important;
        }
        .right_li_uls li h4 {
            padding: 8px 0 0 0;
        }
        .right_li_ul p {
            line-height: 2em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
        }
        .right_li_ul h4{
            padding:0 0 6px 0;
        }
    }

    @media screen and (min-width: 1060px) and (max-width: 1500px) {
        .right_li_ul li h4 {
            margin-top: 10px !important;
            padding:0 0 8px 0;
        }
        .right_li_uls li h4{
            margin-top: 15px !important;
            padding: 10px 0 0 0;
        }
        .right_li_ul p {
            line-height: 1.8em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
        }
    }

    @media screen and (min-width: 1500px) {
        .right_li_ul li h4 {
            margin-top: 12px !important;
            padding: 5px 0 12px 0;
        }
        .right_li_uls li h4{
            margin-top: 20px !important;
            padding: 20px 0 0 0;
        }
        .right_li_ul p {
            line-height: 1.5em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
        }
    }
</style>